export default __webpack_public_path__ + "static/media/xingLogo.7e43e704.svg";